import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const videos = createWorkspaceResourceApi('training-videos')
const trainings = createWorkspaceResourceApi('trainings')

export const trainingVideosApi = {
  list: videos.list,
  get: (workspaceId, id) => apiFetch(`${videos.path(workspaceId)}/${id}`, { ignoreGlobalCatch: true }),
  voices: (workspaceId, params) => apiFetch(`${videos.path(workspaceId)}/voices`, { params }),
  syncVoices: (workspaceId) => apiFetch(`${videos.path(workspaceId)}/voices/sync`, { method: 'POST' }),
  create: videos.create,
  sendMessage: (workspaceId, id, payload) => videos.action(workspaceId, id, 'messages', payload),
  remove: videos.remove,
  attachToTraining: (workspaceId, trainingId, trainingVideoId) =>
    apiFetch(`${trainings.path(workspaceId)}/${trainingId}/attach-video`, {
      method: 'POST',
      body: { training_video_id: trainingVideoId },
    }),
  detachFromTraining: (workspaceId, trainingId) =>
    apiFetch(`${trainings.path(workspaceId)}/${trainingId}/attach-video`, { method: 'DELETE' }),
}
